import React from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import './Footer.css';

class Footer extends React.Component {
  render() {
    return (
      <Router>
        <footer className="footer">
          <div>
            <a className="footer-button fa fa-facebook-official w3-hover-opacity" href="https://www.facebook.com/PartybandRedLines/"> </a> 
            <a className="footer-button fa fa-instagram w3-hover-opacity" href="https://www.instagram.com/redlines_band/"> </a> 
            {/*<a className="footer-button fa fa-snapchat w3-hover-opacity"></a> 
            <a className="footer-button fa fa-pinterest-p w3-hover-opacity"></a> 
            <a className="footer-button fa fa-twitter w3-hover-opacity"></a> 
            <a className="footer-button fa fa-linkedin w3-hover-opacity"></a>*/}
            <br/>
            <Link className="footer-impress w3-hover-opacity" to="/impress" onClick={(event) => this.props.handler(event, 100)}>Impressum</Link>
          </div>
        </footer>
      </Router>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js